import { LLog, LOG_COMPONENTS, LOG_OPERATIONS } from '../../lib/logging';

const FACEBOOK_APP_ID = import.meta.env.VITE_FACEBOOK_APP_ID;

if (!FACEBOOK_APP_ID) {
  LLog.error(
    {
      component: LOG_COMPONENTS.API,
      method: 'facebook',
      operation: LOG_OPERATIONS.ERROR,
    },
    'VITE_FACEBOOK_APP_ID environment variable is not set',
  );
}

export const facebookSDKReady = new Promise<void>((resolve) => {
  if (typeof window === 'undefined') return;
  // An SDK already on the window is ready, and loading it again would add a
  // second script.
  if (window.FB) {
    resolve();
    return;
  }

  window.fbAsyncInit = function () {
    window.FB.init({
      appId: FACEBOOK_APP_ID,
      cookie: true,
      xfbml: true,
      version: 'v21.0',
    });
    resolve();
  };

  const script = document.createElement('script');
  script.src = 'https://connect.facebook.net/en_US/sdk.js';
  script.async = true;
  script.defer = true;
  script.crossOrigin = 'anonymous';
  document.body.appendChild(script);
});
